var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8021 9.1242C14.7475 8.98089 14.652 8.85805 14.5428 8.76251L10.0251 4.24477C9.65654 3.87625 9.05598 3.87625 8.69429 4.24477C8.32577 4.61329 8.32577 5.20701 8.69429 5.57552L11.6356 8.51683L1.88354 8.51001L1.89037 0.941765C1.89037 0.423112 1.46726 0 0.948602 0C0.429948 0 0.00683107 0.423112 0.00683107 0.941765L0 9.44495C0 9.45177 0 9.45177 0 9.4586C0 9.46542 0 9.46542 0 9.47225V9.5132H0.00683107C0.0341287 10.0045 0.436759 10.4004 0.93494 10.4004L11.6834 10.4072L8.69429 13.3963C8.32577 13.7648 8.32577 14.3585 8.69429 14.727C8.87855 14.9113 9.11739 15 9.36307 15C9.60192 15 9.84763 14.9113 10.0319 14.727L14.611 10.1547C14.7885 9.97725 14.8909 9.7384 14.8909 9.4859C14.8772 9.36306 14.8499 9.23339 14.8021 9.1242Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnter);
export default __webpack_public_path__ + "static/media/enter.99d2c8a9.svg";
export { ForwardRef as ReactComponent };